"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIGNUP = void 0;
/* eslint-disable import/prefer-default-export */

var SIGNUP = exports.SIGNUP = 'signup';